import { useHistory } from 'react-router-dom';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import useOrderBook from '../../../order-book/hooks/useOrderBook';
import { useFeatureVisibility } from '../../../permissions/contexts/FeatureVisibilityContext';
import { useTranslation } from '../../../translation/TranslationContext';
import { useAbility } from '../../../users/AbilityContext';
import { STATIC_COMMANDS } from '../staticCommands.registry';
import { StaticCommand, StaticCommandContext } from '../staticCommands.types';
import { hasStaticCommandMatch } from '../staticCommands.utils';

interface UseStaticCommandsParams {
  query: string;
  isStore: boolean;
  onClose: () => void;
}

const useStaticCommands = ({
  query,
  isStore,
  onClose,
}: UseStaticCommandsParams): StaticCommand[] => {
  const history = useHistory();
  const ability = useAbility();
  const { translate } = useTranslation();
  const { isAdminBrand } = useApplicationContext();
  const { isVisible } = useFeatureVisibility();
  const { openOrderBook } = useOrderBook();

  const context: StaticCommandContext = {
    ability,
    isAdminBrand,
    isStore,
    term: query,
    navigate: (path) => history.push(path),
    openOrderBook,
    isMenuVisible: isVisible,
  };

  return STATIC_COMMANDS.filter(
    (command) =>
      command.canAccess(context) &&
      hasStaticCommandMatch({
        label: translate(command.labelKey),
        aliases: command.aliases ?? [],
        query,
      }),
  ).map((command) => ({
    id: command.id,
    type: command.type,
    labelKey: command.labelKey,
    icon: command.icon,
    dispatch: () => {
      onClose();
      command.run(context);
    },
  }));
};

export default useStaticCommands;
